import React, { useRef, useState } from 'react'
import ReactImageGallery from 'react-image-gallery'
import { storagePath } from '@helpers/variables'
import RightNav from './RightNav'
import LeftNav from './LeftNav'
import Text from '@components/Text'
import { COLORS, TEXT_ALIGN, TEXT_SIZES } from '@helpers/constants'
import { useResponsive } from '@hooks/useResponsive'

const RenderItem = (props) => {
  const { original, heading, preamble, textAlign, textColor } = props
  const { breakpoints } = useResponsive()

  return (
    <div className='relative cursor-default'>
      <div
        className='relative height-0 pb-[26.04%] overflow-hidden'
        onClick={(e) => e.stopPropagation()}
      >
        <img
          className='object-cover absolute top-0 left-0 w-full h-full'
          width='1920'
          height='500'
          src={original}
          alt=''
          srcSet=''
          sizes=''
          title=''
        />

        <div
          className={`absolute h-full w-full top-0 px-24 flex flex-col justify-center ${
            textAlign === TEXT_ALIGN.LEFT && 'items-start'
          } ${textAlign === TEXT_ALIGN.CENTER && 'items-center'} ${
            textAlign === TEXT_ALIGN.RIGHT && 'items-end'
          } ${textAlign ?? 'text-left'} whitespace-normal`}
        >
          <div className={'w-1/2 xl:w-1/3'}>
            <h1
              color={textColor ?? COLORS.WHITE.TEXT}
              className='text-white font-bold mb-2'
              style={{
                fontSize: breakpoints.wide ? '40px' : '48px',
                lineHeight: 1,
              }}
            >
              {heading}
            </h1>
            <Text
              size={TEXT_SIZES.LARGE}
              color={textColor ?? COLORS.WHITE.TEXT}
            >
              {preamble}
            </Text>
          </div>
        </div>
      </div>
    </div>
  )
}

RenderItem.displayName = 'RenderItem'

const MemoizedRenderItem = React.memo(RenderItem)

const OnboardingCarousel = () => {
  const ref = useRef()
  const [currentIndex, setCurrentIndex] = useState(0)

  const images = window.slideshow_slides
    ? window.slideshow_slides.map((slide) => {
        return {
          original: storagePath + `/${slide.image}`,
          heading: slide.heading,
          preamble: slide.text,
        }
      })
    : null

  if (!images) return null

  return (
    <div className={'relative overflow-hidden'}>
      <ReactImageGallery
        ref={(rig) => (ref.current = rig)}
        showPlayButton={false}
        showFullscreenButton={false}
        showThumbnails={false}
        // autoPlay
        useTranslate3D
        onBeforeSlide={(index) => setCurrentIndex(index)}
        slideInterval={6000}
        onMouseOver={() => {
          ref?.current?.pause()
        }}
        onMouseLeave={() => {
          ref?.current?.play()
        }}
        items={images}
        renderItem={(item) => (
          <MemoizedRenderItem
            {...item}
            onClose={() => {
              console.log()
            }}
          />
        )}
        renderLeftNav={(onClick, disabled) => (
          <LeftNav
            onClick={(e) => {
              e.stopPropagation()
              onClick()
            }}
            disabled={disabled}
          />
        )}
        renderRightNav={(onClick, disabled) => (
          <RightNav
            onClick={(e) => {
              e.stopPropagation()
              onClick()
            }}
            disabled={disabled}
          />
        )}
      />

      <div className={'absolute bottom-4 left-1/2 -translate-x-1/2 flex'}>
        {images.map((image, index) => (
          <div
            key={index}
            className={`h-[12px] w-[12px] m-[6px] transition-colors hover:bg-black ${
              currentIndex === index ? 'bg-black' : ''
            } cursor-pointer rounded-full border`}
            onClick={() => {
              setCurrentIndex(index)
              ref?.current?.slideToIndex(index)
            }}
          />
        ))}
      </div>
    </div>
  )
}

OnboardingCarousel.propTypes = {}

export default OnboardingCarousel
